export class SharedRouteNames {
  public static readonly iFrameRoutes = {
    driftstatus: "driftstatus",
    driftstatusMap: "driftstatus-map",
    subscription: "subscription",
    stdReceivers: "std-receivers",
    confirmTwitter: "confirm-twitter"
  };

  public static readonly unavailable = "unavailable";
}
